export default __webpack_public_path__ + "static/Sandbox-f2c395b1e9398a9f69b6465e8e386fb9.png";